import { ColumnWidthIndicator } from "../ColumnWidthIndicator";

const ColumnWidthToggleButton = ({
  active = false,
  onToggle, // callback receives the new state (true/false)
}) => {
  const handleClick = () => {
    if (onToggle) {
      onToggle(!active);
    }
  };

  return (
    <div className="toggle-button" style={{ display: "flex" }}>
      <button
        onClick={handleClick}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
        }}
        aria-label="Toggle column width"
      >
        {active ? (
          // Active state: narrow column icon (16x16)
          <ColumnWidthIndicator />

        ) : (
          // Inactive state: default column icon (24x24)
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 4L19 20M5 20L5 4M10 8L10 16C10 16.5523 10.4477 17 11 17L13 17C13.5523 17 14 16.5523 14 16L14 8C14 7.44772 13.5523 7 13 7L11 7C10.4477 7 10 7.44772 10 8Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>
    </div>
  );
};

export default ColumnWidthToggleButton;
